module.exports = __webpack_public_path__ + "img/2.12c045a2.jpg";